// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-app--dashboardApp--3ye6IRev {\n  font: 300 16px/1.4 museo-sans, verdana, helvetica, arial, sans-serif;\n  overflow: hidden;\n  color: #3f3f3f;\n  margin: 0;\n  padding: 0;\n}\n.dashboard-app--dashboardApp--3ye6IRev .dashboard-app--title--2xeorPN4 {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  padding: 20px 20px 0 20px;\n}\n.dashboard-app--dashboardApp--3ye6IRev h1 {\n  font: 700 24px museo, verdana, helvetica, arial, sans-serif;\n}\n@media print {\n  .dashboard-app--dashboardApp--3ye6IRev {\n    font-size: 10pt !important;\n  }\n}\n@page {\n  margin: 1cm;\n}\n", ""]);
// Exports
exports.locals = {
	"dashboardApp": "dashboard-app--dashboardApp--3ye6IRev",
	"title": "dashboard-app--title--2xeorPN4"
};
module.exports = exports;
